import type { AllHTMLAttributes } from 'react';
import {
  BannerFixedBox,
  BannerBox,
} from './Banner.styled';

export interface BannerProps extends AllHTMLAttributes<HTMLDivElement> {
  show?: boolean;
  placement?: 'top' | 'bottom';
}

export function Banner({
  show,
  placement = 'top',
  children,
}: BannerProps) {
  return (
    <BannerFixedBox
      show={show}
      placement={placement}
    >
      <BannerBox
        show={show}
        placement={placement}
      >
        {children}
      </BannerBox>
    </BannerFixedBox>
  );
}
